import { render, staticRenderFns } from "./axios-chart.vue?vue&type=template&id=79d94092&"
import script from "./axios-chart.vue?vue&type=script&lang=ts&"
export * from "./axios-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports